import { Component, OnInit } from '@angular/core';
import { DxReportViewerModule } from 'devexpress-reporting-angular';
import { environment } from 'src/environments/environment.prod';
// import { SourceOfmarketing } from 'src/app/shared/Models/source-ofmarketing';

@Component({
  selector: 'app-reports-service',
  templateUrl: './reports-service.component.html',
  styleUrls: [
    "../../../../../../node_modules/jquery-ui/themes/base/all.css",
    "../../../../../../node_modules/devextreme/dist/css/dx.light.css",
    "../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
    "../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css",
    "../../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css"
  ]
})
export class ReportsServiceComponent  {

  ReportsFiter :any  
  title = 'DXReportViewerSample';
  reportUrl: string = localStorage["ReportName"];
  // hostUrl: string = 'https://localhost:44373/';
  hostUrl: string = environment.ServerImages_URL+'/';
  // hostUrl: string = 'https://afdhalsadakaapi.wecancity.com/';
  // Use this line if you use an ASP.NET MVC backend
  //invokeAction: string = "/WebDonncumentViewer/Invoke";
  // Use this line if you use an ASP.NET Core backend
  invokeAction: string = 'DXXRDV';

  parametersSubmitted(event:any) {
    var filter:any = localStorage.getItem("ReportFilter");
    this.ReportsFiter = JSON.parse(filter);
    Object.keys(this.ReportsFiter).forEach
      (e => event.args.Parameters.filter(function (p:any) {return p.Key == e;  })[0].Value = this.ReportsFiter[e] != '' ? this.ReportsFiter[e] : null);
     }


     
}
